import { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import Image from "next/image";
import style from "./DownLoadModal.module.scss";
import DoneIcon from "../../../public/remove_back/magic_bg/interior_promo/done_icon.svg";
import CloseIcon from "../../../public/remove_back/magic_bg/interior_promo/purple_close_icon.svg";
import * as ga from "../../../lib/ga";

function DownLoadModal({ image_url = "", closeHandler = () => {}, dictionary, pageName = "" }) {
	const [progress, setProgress] = useState(0);
	const [isSuccess, setIsSuccess] = useState(false);
	const timerRef = useRef(null);

	const gaInteriorPromo = (e) => {
		if (e?.target?.tagName?.toLowerCase() === "a") {
			ga.event({
				action: `Interior promo: link click`,
				params: {
					event_category: `${pageName}: download modal`,
				},
			});
		}
	};

	useEffect(() => {
		if (progress !== 100) {
			timerRef.current = setTimeout(() => {
				setProgress(progress + 20);
			}, 500);
		} else {
			setTimeout(() => {
				setIsSuccess(true);
			}, 600);
			clearTimeout(timerRef.current);
		}

		return () => {
			clearTimeout(timerRef.current);
		};
	}, [progress]);

	useEffect(() => {
		if (image_url) {
			setProgress(0);
			setIsSuccess(false);
		}
	}, [image_url]);

	return ReactDOM.createPortal(
		<div className={style.container} style={{ zIndex: "10" }}>
			<div className={style.header}>
				<button className={style.closeBtn} onClick={closeHandler}>
					<CloseIcon />
				</button>
				<Image src={image_url} loader={({ src }) => src} className={style.headerImage} width={60} height={60} alt="Generated image" priority={true} />
				<div className={style.modalInfo}>
					<div className={style.text}>
						{isSuccess ? (
							<p className={style.successText}>
								{dictionary["downloaded"] || "Downloaded"} <DoneIcon className={style.icon} />
							</p>
						) : (
							<p className={style.loadingText}>{dictionary["downloading"] || "Downloading ..."}</p>
						)}
					</div>
					<div className={style.progressWrapper}>
						<div
							className={style.progressLine}
							style={{
								width: `${progress}%`,
								transition: `all linear ${progress > 1 ? "500ms" : "0ms"}`,
							}}
						></div>
					</div>
				</div>
			</div>
			<div className={style.image} />
			<div
				onClick={(e) => {
					gaInteriorPromo(e);
				}}
				className={style.mainText}
				dangerouslySetInnerHTML={{ __html: `${dictionary["interior_redesign_ad2"]}` }}
			></div>
		</div>,
		document.getElementById("portal")
	);
}

export default DownLoadModal;
